<template>
    <all-topics type="department" />
</template>

<script>
import AllTopics from './All'

export default {
    components: { AllTopics },
    name: 'Department',
}
</script>